import { graphql, useStaticQuery } from "gatsby";

export type IBreadcrumbData = {
  allWpPage: {
    nodes: {
      title: string;
      id: string;
      uri: string;
      parentId: string;
    }[];
  };
};

const useBreadcrumbData = () => {
  const { allWpPage }: IBreadcrumbData = useStaticQuery(graphql`
    {
      allWpPage {
        nodes {
          title
          id
          uri
          parentId
        }
      }
    }
  `);

  return allWpPage.nodes;
};
export default useBreadcrumbData;
